// extracted by mini-css-extract-plugin
export default {"root":"FCi93VSypm3Oe9EJx1X8","main":"TmObUPCPR8lSEtcUl8al","pad":"XZgihzohqXiz1fXcIeQa","col":"f1_PzHcxdZtC0F7UP75A","box":"D8uaRE7htl9LnrCbujAE","badge":"Bmr4GoWP677SpR3uRF0P"};